import { assetPrefix } from 'config/env_config'
import React from 'react'
import { useRouter } from 'next/router'
import NextLink from 'next/link'
import styled from 'styled-components'
import { FaChevronLeft } from 'react-icons/fa'
import { MEDIA, PAGE_URL } from 'utils'

const Container = styled.div`
  max-width:calc(100% - 50px);
  width:980px;
  display:flex;
  margin:0 auto;
  font-family: var(--primary-font);
`
const Banner = styled.div`
  background-image: url('${assetPrefix}/static/images/como-funciona/ameba.svg');
  background-size:100%;
  background-repeat:no-repeat;
  background-position:left bottom;
  width:100%;
  height:405px;
  display:flex;

  > div {
    width:1040px;
    flex-direction:column;

    &::before{
      content:'';
      background-image: url('${assetPrefix}/static/images/como-funciona/line-ameba.svg');
      background-repeat:no-repeat;
      background-size:100%;
      background-position:0 -214px;
      width:900px;
      height:230px;
      position:absolute;
      margin-left:-40px;
      z-index:1;

      @media screen and ${MEDIA.MOBILE} {
        margin-left:-30px;
        background-image: url('${assetPrefix}/static/images/como-funciona/line-ameba-mob.svg');
        background-position:-240px bottom;
        width:600px;
      }

    }
  }

  @media screen and ${MEDIA.MOBILE} {
    background-image: url('${assetPrefix}/static/images/como-funciona/ameba-mob.svg');
    background-position:-270px -25px;
    background-size:auto 104%;
    background-repeat:no-repeat;
    height:315px;
  }

`
const Title = styled.h2`
  margin-top:15px;
  color:var(--the-white);
  font-size:34px;
  line-height:46px;
  font-weight:600;

  @media screen and ${MEDIA.MOBILE} {
    text-align:center;
    font-size:22px;
    line-height:26px;
    font-weight:1000;

    br{
      display:none;
    }
  }
`

const RowStepsTitle = styled.div`
  display:flex;
  flex-direction:column;
  margin:0 auto;
  max-width:calc(100% - 50px);
  font-family: var(--primary-font);
`

const StepsTitle = styled.h3`
  text-align:center;
  color:var(--cobasi-blue);
  font-size:40px;
  font-weight:600;

  strong{
    font-weight:1000;
  }

  @media screen and ${MEDIA.MOBILE} {
    font-size:27px;
    line-height:28px;
  }
`
const StepsDescription = styled.p`
  text-align:center;
  color:var(--cobasi-blue-light-3);
  font-size:25px;
  line-height:32px;

  @media screen and ${MEDIA.MOBILE} {
    font-size:17px;
    line-height:20px;
    margin-top:10px;

    br{
      display:none;
    }
  }
`
const Row = styled.div`
  display:flex;
  width:100%;

  @media screen and ${MEDIA.MOBILE} {
    flex-direction:column;
  }
`
const Image = styled.div`
  margin-left:auto;
  margin-top:15px;
  margin-bottom:-15px;
  z-index:2;

  img {
    height:95%;
  }

  @media screen and ${MEDIA.MOBILE} {
    width:250px;
    margin:15px auto 0 auto;
    img{
      height:auto;
      width:100%;
    }
  }
`
const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  color: var(--the-white);
  font-size: 15px;
  font-family: var(--primary-font);
  font-weight: bold;
  cursor: pointer;
  line-height: 0;
  margin: 12px 0;

  & > span {
    margin-left: 3px;
    margin-top: 2px;
  }

  @media screen and ${MEDIA.MOBILE} {
    font-size: 18px;
  }
`
const Steps = styled.div`
  display:flex;
  justify-content:space-between;
  flex-wrap:wrap;
  margin-top:30px;

  @media screen and ${MEDIA.MOBILE} {
    flex-direction:column;
  }

  @media screen and ${MEDIA.DESKTOP_UP} {
    margin-bottom:30px;
  }
`
const Step = styled.div`
  display:flex;
  flex-direction:column;
  margin-right:auto;
  align-items:center;
  max-width:100%;  

  img {
    width:100%;
  }

  @media screen and ${MEDIA.DESKTOP_UP} {
    max-width:calc(50% - 30px);
    margin:${props => props.margin ? props.margin : '0'};
    width:${props => props.width ? props.width : 'auto'};
  }

  @media screen and ${MEDIA.MOBILE} {
    border-bottom:2px dashed rgba(0, 197, 219, 0.2);
    padding-bottom:25px;
    margin:0 0 25px 0;

    &:last-child{
      margin-bottom:0 !important;
    }
  }

`
const StepTitle = styled.h4`
  color:var(--cobasi-blue);
  font-size:26px;
  line-height:32px;
  font-weight:bold;
  text-align:center;
  margin-top:5px;

  strong{
    font-weight:1000;
  }

  @media screen and ${MEDIA.MOBILE} {
    font-size:18px;
    line-height:22px;
    font-weight:1000;

    br, span{
      display:none;
    }
  }
`
const RowExtraInfo = styled.div`
  display:flex;
  align-items:center;
  background:var(--the-white);

  > div {
    align-items:center;
  }

  img {
    padding:5px 0 30px 0;
  }

  @media screen and ${MEDIA.MOBILE} {
    padding-bottom:30px;

    img {
      padding:20px 0 0 0;
    }

    > div {
      flex-direction:column;
    }
  }
`
const ExtraInfo = styled.div`
  display:flex;
  flex-direction:column;
  text-align:center;
  width:60%;
  margin-left:30px;
  justify-content:center;

  @media screen and ${MEDIA.MOBILE} {
    width:100%;
    margin:15px 0 0 0;
  }
`
const ExtraInfoTitle = styled.h4`
  color:var(--cobasi-orange);
  font-size:26px;
  line-height:32px;

  @media screen and ${MEDIA.MOBILE} {
    font-size:16px;
    line-height:32px;
  }
`
const ExtraInfoDescription = styled.p`
  color:var(--cobasi-orange);
  font-size:22px;
  line-height:28px;
  margin-top:5px;

  strong{
    font-weight:800;
  }

  @media screen and ${MEDIA.MOBILE} {
    font-size:13px;
    line-height:20px;
  }
`
const ExtraInfoObs = styled.p`
  color:var(--cobasi-blue-light-2);
  font-size:19px;
  line-height:24px;
  margin-top:15px;
  font-style:italic;

  @media screen and ${MEDIA.MOBILE} {
    font-size:13px;
    line-height:18px;
  }
`
const ButtonMoreInfo = styled.a`
  color:var(--the-white);
  background:var(--cobasi-blue);
  padding:20px 35px;
  font-weight:bold;
  border:none;
  align-self:center;
  border-radius:12px;
  margin:40px auto;
  font-size:26px;
  cursor:pointer;

  @media screen and ${MEDIA.MOBILE} {
    font-size:17px;
    line-height:22px;
    text-align:center;
    margin:30px auto;
  }
`

const ComoFunciona = ({ onClick }) => {
  const router = useRouter()

  const handleClick = onClick || (e => {
    e.preventDefault()
    router.back()
  })

  return (
    <>
      <Banner>
        <Container>
          <Row>
            <Title>
              <BackButtonContainer onClick={handleClick}>
                <FaChevronLeft size={18} />
                <span>Voltar</span>
              </BackButtonContainer>
              Como funciona o <br />
              Marketplace de Serviços <br />
              Cobasi
            </Title>
            <Image>
              <img alt='imagem banner como funciona' src={`${assetPrefix}/static/images/como-funciona/content-banner-desk.svg`} />
            </Image>
          </Row>
        </Container>
      </Banner>

      <RowStepsTitle>
        <StepsTitle>
          Conectando os melhores <strong>parceiros</strong> aos <strong>clientes.</strong>
        </StepsTitle>
        <StepsDescription>
          Aqui você encontra nossos parceiros, empresas e profissionais especializados<br /> em diversos serviços, agende o que procura para seu Pet.
        </StepsDescription>
      </RowStepsTitle>

      <Container>
        <Steps>
          <Step width='35%'>
            <picture>
              <source srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-1-mob.png`} media={MEDIA.MOBILE} />
              <img srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-1-desk.png`} alt='login' />
            </picture>
            <StepTitle>Faça o login <span>do site <br />Cobasi</span> ou crie uma conta</StepTitle>
          </Step>
          <Step margin='60px 60px 0 0'>
            <picture>
              <source srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-2-mob.png`} media={MEDIA.MOBILE} />
              <img srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-2-desk.png`} alt='serviços' />
            </picture>
            <StepTitle>Selecione um dos <br /> nossos serviços</StepTitle>
          </Step>
          <Step margin='-60px 0 0 60px'>
            <picture>
              <source srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-3-mob.png`} media={MEDIA.MOBILE} />
              <img srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-3-desk.png`} alt='pets' />
            </picture>
            <StepTitle>Cadastre seus<br /> pets</StepTitle>
          </Step>
          <Step width='35%' margin='30px 30px 0 0'>
            <picture>
              <source srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-4-mob.png`} media={MEDIA.MOBILE} />
              <img srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-4-desk.png`} alt='profissionais' />
            </picture>
            <StepTitle>Escolha o local e o<br /> profissional</StepTitle>
          </Step>
          <Step margin='-140px 0 0 30px'>
            <picture>
              <source srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-5-mob.png`} media={MEDIA.MOBILE} />
              <img srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-5-desk.png`} alt='horários' />
            </picture>
            <StepTitle>Escolha o melhor dia <br /> e horário!</StepTitle>
          </Step>
          <Step margin='30px 0 0 0'>
            <picture>
              <source srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-6-mob.png`} media={MEDIA.MOBILE} />
              <img srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-6-desk.png`} alt='sucesso' />
            </picture>
            <StepTitle>
              <strong>Pronto!</strong> Lembre-se que o<br />pagamento é feito no local,<br /> logo após o serviço ser finalizado.
            </StepTitle>
          </Step>
        </Steps>
      </Container>
      <RowExtraInfo>
        <Container>
          <picture>
            <source srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-!-mob.png`} media={MEDIA.MOBILE} />
            <img srcSet={`${assetPrefix}/static/images/como-funciona/content-iten-!-desk.png`} alt='sucesso' />
          </picture>
          <ExtraInfo>
            <ExtraInfoTitle> Como faço para cancelar ou reagendar? </ExtraInfoTitle>
            <ExtraInfoDescription>
              Na tela inicial, na área de <strong>Minha Agenda</strong>, clique no agendamento que deseja <strong>editar</strong> e inicie o processo de cancelamento ou reagendamento do seu serviço.
            </ExtraInfoDescription>
            <ExtraInfoObs>
              *Nossa central atende os agendamentos feitos online, de todos locais e profissionais parceiros cadastrados.
            </ExtraInfoObs>
          </ExtraInfo>
        </Container>
      </RowExtraInfo>
      <Container>
        <NextLink href={PAGE_URL.SERVICE_TERMS}>
          <ButtonMoreInfo>Para mais informações sobre as regras de atendimento, <u>clique aqui</u></ButtonMoreInfo>
        </NextLink>
      </Container>
    </>
  )
}

export default ComoFunciona
